import React, { createContext } from "react";
import { Link } from "react-router-dom";

import "./Footer.css";
import {routes} from "../Header/Header";
import logo from "../../images/Logo/LogoName.png";

function Footer() {
  return (
    <div className="footer">
      <div className="footer__bottom">
        <div className="footer__bottom-cont1">
          <div className="footer__bottom-items1">
            <div className="footer__bottom-items1-header">
              <img src={logo}/>
            </div>
            <div className="footer__bottom-items1-text">
              ООО "ДКМ Системы" <br/>
              ИНН 7736332142 КПП 773601001 <br/>
              119331, г. Москва, Проспект <br/>
              Вернадского, 29
            </div>
          </div>
          <div className="footer__bottom-items1">
            <div className="footer__bottom-items1-header">КОНТАКТЫ</div>
            <div className="footer__bottom-items1-contact">
              +74951294500 <br/>
              info@dkmsys.ru
            </div>
          </div>
          {/* <div className="footer__bottom-items1">
            <div className="footer__bottom-items1-header">МЕНЮ</div>
            <div>
              {routes.map((route) => {
                const { href, title } = route;
                return (
                  <>
                    <Link className="footer__bottom-items1-link" to={href}> {title} </Link>
                    <br/>
                  </>
                )
              })}
            </div>
          </div> */}
        </div>
      </div>
      <div className="footer__bottom">
        <div className="footer__bottom-cont2">
          <div className="footer__bottom-items2">Copyright &copy; 2023-2025 dkmsys.ru</div>
          <div className="footer__bottom-items2">Политика конфиденциальности</div>
          <div className="footer__bottom-items2">Публичная оферта</div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
 